export default [
    { path: '/admissionRequest', component: require('./components/admissions/requestadmission.vue').default },
     { path: '/chage_password', component: require('./components/profile/change_password.vue').default },

    { path: '/track_application', component: require('./components/admissions/track_application.vue').default },
    { path: '/',name:'', component: require('./components/Dashboard.vue').default }, 
    { path: '/dashboard', name:'dashboard', component: require('./components/Dashboard.vue').default },
    { path: '/userprofile', component: require('./components/Profile/Userprofile.vue').default },
    { path: '/passReset', component: require('./components/profile/password_reset.vue').default },
    { path: '/result', component: require('./components/results/result.vue').default },
    { path: '/classxi_student', name:'classxi_student', component: require('./components/admissions/classxi_student.vue').default },
    // { path: '*', component: require('./components/NotFound.vue').default },

    { path: '/new_admission_page',name:'new_admission_page', component: require('./components/new_admission_transfer/new_registration_for_admission.vue').default },
    // { path: '/admission_initiated',name:'admission_initiated', component: require('./components/admissions/admission_initiated.vue').default },
    { path: '/new_application', name:'new_application', component: require('./components/admissions/new_application.vue').default },
    { path: '/acknowledgement',name:'acknowledgement', component: require('./components/admissions/acknowledgement.vue').default },
    { path: '/acknowledgement_admission',name:'acknowledgement_admission', component: require('./components/admissions/acknowledgement_admission_request.vue').default },

    { path: '/admission',  name:'admission',  component: require('./components/admissions/admission.vue').default ,
        children:[
            { path: '/notenrolled_student',name:'notenrolled_student', component: require('./components/admissions/notenrolled_student.vue').default },
            { path: '/enrolled_student',name:'enrolled_student', component: require('./components/admissions/enrolled_student.vue').default },
            { path: '/admission_initiated',name:'admission_initiated', component: require('./components/admissions/admission_initiated.vue').default },
        ]

    },
    //new registrartion
    { path: '/new_registration_index',  name:'new_registration_index',  component: require('./components/new_registration/new_registration_index.vue').default ,
    children:[
        { path: '/',name:'list_new_registration', component: require('./components/new_registration/list_new_registration.vue').default },
        { path: '/create_new_registration',name:'create_new_registration', component: require('./components/new_registration/create_new_registration.vue').default },
        { path: '/Already_Registered',name:'Already_Registered', component: require('./components/new_registration/Already_Registered.vue').default },
        { path: '/edit_new_registration',name:'edit_new_registration', component: require('./components/new_registration/edit_new_registration.vue').default },
    ]
    },
     //request for admission
     { path: '/request_for_admission_index',  name:'request_for_admission_index',  component: require('./components/request_for_admission/request_for_admission_index.vue').default ,
        children:[
            { path: '/',name:'list_admission_request', component: require('./components/request_for_admission/list_admission_request.vue').default },
            { path: '/create_admission_request',name:'create_admission_request', component: require('./components/request_for_admission/create_admission_request.vue').default },
            { path: '/edit_admission_request',name:'edit_admission_request', component: require('./components/request_for_admission/edit_admission_request.vue').default },
            { path: '/action_admission',name:'action_admission', component: require('./components/request_for_admission/action_admission.vue').default },
        ]
    },
    //Annocement
    { path: '/annocement_index',  name:'annocement_index',  component: require('./components/Anoucement/annocement_index.vue').default ,
    children:[
            { path: '/',name:'annocement_index', component: require('./components/Anoucement/list_annocement.vue').default },
            { path: '/list_annocement',name:'list_annocement', component: require('./components/Anoucement/list_annocement.vue').default },
                { path: '/create_annocement',name:'create_annocement', component: require('./components/Anoucement/create_annocement.vue').default },
                { path: '/edit_annocement',name:'edit_annocement', component: require('./components/Anoucement/edit_annocement.vue').default },
            ]
    },

    { path: '/admission_transfer_index', component: require('./components/new_admission_transfer/new_admission_transfer_index.vue').default ,
        children:[
            { path: '/',name:'admission_transfer_index', component: require('./components/new_admission_transfer/list_new_admission_transfer.vue').default },
            { path: '/create_new_admission_transfer',name:'create_new_admission_transfer', component: require('./components/new_admission_transfer/create_new_admission_transfer.vue').default },
            { path: '/new_registration_for_admission',name:'new_registration_for_admission', component: require('./components/new_admission_transfer/new_registration_for_admission.vue').default },
            { path: '/edit_new_admission_transfer',name:'edit_new_admission_transfer', component: require('./components/new_admission_transfer/edit_new_admission_transfer.vue').default },
            { path: '/list_new_admission_transfer',name:'list_new_admission_transfer', component: require('./components/new_admission_transfer/list_new_admission_transfer.vue').default },
        ]
    },
    { path: '/track_application',  name:'track_application',  component: require('./components/admissions/track_application.vue').default ,
        children:[
                { path: '/applicationLists',name:'applicationLists', component: require('./components/admissions/applicationLists.vue').default },
        ]
    },
    //configuration
    { path: '/configuration_index',  name:'configuration_index',  component: require('./components/Configuration/configuration_index.vue').default ,
    children:[
            { path: '/',name:'configuration_index', component: require('./components/Configuration/list_configuration.vue').default },
            { path: '/list_configuration',name:'list_configuration', component: require('./components/Configuration/list_configuration.vue').default },
                { path: '/create_configuration',name:'create_configuration', component: require('./components/Configuration/create_configuration.vue').default },
                { path: '/edit_configuration',name:'edit_configuration', component: require('./components/Configuration/edit_configuration.vue').default },
            ]
    },

    //applying to private school
    {
        path: '/applying_to_private_school',
        name: 'applying_to_private_school',
        component: require('./components/applyingPrivateSchool/applying_to_private_school.vue').default,
    },

    //applying to within cluster
    {
        path: '/applying_to_cluster_school',
        name: 'applying_to_cluster_school',
        component: require('./components/applyingClusterSchool/applying_to_cluster_school.vue').default,
    },

      //applying to outside cluster
    {
        path: '/applying_to_Out_side_cluster_school',
        name: 'applying_to_Out_side_cluster_school',
        component: require('./components/applyingOutsideClusterSchool/applying_to_Out_side_cluster_school.vue').default,
    },

    {
        path: '/class-xi-admission',
        name: 'class-xi-admission',
        component: require('./components/class_xi_admission/tab_container.vue').default,
    },
    {
        path: '/class-xi-admission/edit',
        name: 'class-xi-admission-edit',
        component: require('./components/class_xi_admission/edit_admitted_students.vue').default,
    },
    {
        path: '/apply_for_school_ackowlegement',  name: 'apply_for_school_ackowlegement', component: require('./components/admissions/apply_for_school_ackowlegement.vue').default,
    },
    {
        path: '/apply_for_school',  name: 'apply_for_school', component: require('./components/admissions/apply_for_school.vue').default,
        
     
    },
    
    {
        path: '/admission-details',
        name: 'admission-details',
        component: require('./components/class_xi_admission/admission_detail_tab_school.vue').default
    },
];
